import { ChangeRequestAddressModel } from "./change-requests";

export class PayrollAddressModel {
    homeAddressLine1: string;
    homeAddressLine2: string;
    homeCity: string;
    homeState: string;
    homeZipCode: string;
    lastUpdated: string;
    currentChangeRequestAddressModel: ChangeRequestAddressModel;

    constructor() {
        this.homeAddressLine1 = null;
        this.homeAddressLine2 = null;
        this.homeCity = null;
        this.homeState = null;
        this.homeZipCode = null;
        this.lastUpdated = null;
        this.currentChangeRequestAddressModel = new ChangeRequestAddressModel();
    }
}


export class DeductionsModel {
    miscDeductions: MiscDeductionDetail[];
    miscTotalAmount: number;
    benefitDeductions: BenefitDeductionDetail[];
    benefitTotalAmount: number;
    wageAttachmentDeductions: WageAttachmentDeductionDetail[];
    wageAttachmentsTotalAmount: number;
    arrearsDeductions: ArrearsDeductionDetail[];
    arrearsTotalAmount: number;

    constructor() {
        this.miscDeductions = new Array<MiscDeductionDetail>();
        this.miscTotalAmount = null;
        this.benefitDeductions = new Array<BenefitDeductionDetail>();
        this.benefitTotalAmount = null;
        this.wageAttachmentDeductions = new Array<WageAttachmentDeductionDetail>();
        this.wageAttachmentsTotalAmount = null;
        this.arrearsDeductions = new Array<ArrearsDeductionDetail>();
        this.arrearsTotalAmount = null;
    }
}

export class MiscDeductionDetail {
    deduction: string;
    amount: number;

    constructor() {
        this.deduction = null;
        this.amount = null;
    }
}

export class BenefitDeductionDetail {
    deduction: string;
    amount: number;

    constructor() {
        this.deduction = null;
        this.amount = null;
    }

}

export class WageAttachmentDeductionDetail {
    agencyName: string;
    deductionType: string;
    amount: string;

    constructor() {
        this.agencyName = null;
        this.deductionType = null;
        this.amount = null;
    }
}

export class ArrearsDeductionDetail {
    deduction: string;
    amount: number;

    constructor() {
        this.deduction = null;
        this.amount = null;
    }
}


export class PTOModel {
    sickLeaveAccured: number;
    sickLeaveUsed: number;
    sickLeaveAvailable: number;
    vacationAccured: number;
    vacationUsed: number;
    vacationAvailable: number;

    constructor() {
        this.sickLeaveAccured = 0;
        this.sickLeaveAvailable = 0;
        this.sickLeaveUsed = 0;
        this.vacationAccured = 0;
        this.vacationAvailable = 0;
        this.vacationUsed = 0;
    }
}

export class DashboardPayCheckModel {
    payrollHeaderId: number;
    checkDate: string;
    netPay: number;
    taxes: number;
    deductions: number;

    constructor() {
        this.payrollHeaderId = 0;
        this.checkDate = null;
        this.netPay = 0;
        this.taxes = 0;
        this.deductions = 0;
    }
}

export class AnnualStatementsModel {
    memberDocumentId: number;
    description: string;
    createdDate: string;

    constructor() {
        this.memberDocumentId = 0;
        this.description = null;
        this.createdDate = null;
    }
}

export class StatementModel {
    memberDocumentId: number;
    payrollHeaderId: number;

    constructor() {
        this.memberDocumentId = 0;
        this.payrollHeaderId = 0;
    }
}

export class AnnualStatementEmailCriteria {
    annualStatementId: number;
    toAddress: string;

    constructor() {
        this.annualStatementId = 0;
        this.toAddress = null;
    }
}

export class PayStatementEmailCriteria {
    payStatementId: number;
    toAddress: string;

    constructor() {
        this.payStatementId = 0;
        this.toAddress = null;
    }
}

export class FilingStatus {
    value: string;
    valueInt: number;
    text: string;
}


export class DirectDepositModel {
    iD: number;
    memberId: number;
    paymentOptionTypeId: number;
    bankName: string;
    routingNumber: string;
    accountNumber: string;
    accountNumberForValidation: string;
    isDefault: boolean;
    errorMessage: string;

    constructor() {
        this.iD = 0;
        this.memberId = 0;
        this.paymentOptionTypeId = 0;
        this.bankName = null;
        this.routingNumber = null;
        this.accountNumber = null;
        this.accountNumberForValidation = null;
        this.isDefault = false;
        this.errorMessage = null;
    }
}
